import createShopifyRecommendationsEngine, {
  SHOPIFY_COMPLEMENTARY,
  SHOPIFY_RELATED,
} from './ShopifyRecommendations';

const createPhillRecommendations = ({
  sectionId,
  limit = 10,
  itemQuery = null,
}) => {

  const shopifyRecommendationsEngine = createShopifyRecommendationsEngine({
    sectionId,
    itemQuery,
    limit,
  });

  const getRecommendationEngine = (type) => {
    const useShopify = [SHOPIFY_COMPLEMENTARY, SHOPIFY_RELATED].includes(type);

    if (useShopify) {
      return shopifyRecommendationsEngine;
    }

    return null;
  };

  const query = async (...queries) => {
    const promises = queries.map(([recommendationType, items = []]) => {
      const engine = getRecommendationEngine(recommendationType);

      if (engine) return engine.query(recommendationType, items);

      // Recommendation type isn't supported
      return Promise.resolve(null);
    });

    try {
      const results = await Promise.all(promises);
      return results;
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
      return [];
    }
  };

  return [query];
};

export default class {
  constructor(...args) {
    [this.query] = createPhillRecommendations(...args);
  }
}
